import { useEffect, useState } from 'react';
import { listEvents } from '../api.js';
import { hapticFeedback, hideBackButton } from '../lib/twa.js';


function formatLocal(iso) {
  if (!iso) return '';
  try {
    return new Intl.DateTimeFormat(undefined, {
      dateStyle: 'medium',
      timeStyle: 'short',
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    }).format(new Date(iso));
  } catch {
    return iso;
  }
}

function openCreate() {
  hapticFeedback('selection');
  window.location.hash = '#/new';
}

export default function EventList({ chat }) {
  const [events, setEvents] = useState(null);
  const [error, setError] = useState(null);
  const [archived, setArchived] = useState(false);

  useEffect(() => {
    hideBackButton();
  }, []);

  async function refresh() {
    try {
      const data = await listEvents(chat.id, { archived });
      setEvents(data.events);
    } catch (e) {
      setError(e);
    }
  }

  useEffect(() => {
    refresh();
  }, [chat.id, archived]);

  if (error) {
    return (
      <div className="notice">
        <h2>Failed to load events</h2>
        <div className="error">{error.message}</div>
      </div>
    );
  }

  if (events === null) {
    return <div className="notice">Loading…</div>;
  }

  return (
    <div>
      <div className="row between" style={{ marginBottom: 12 }}>
        <h1 className="page-header" style={{ margin: 0 }}>{chat.title || 'Chat calendar'}</h1>
        <button onClick={openCreate} aria-label="New event">+ New event</button>
      </div>
      <div className="row" style={{ marginBottom: 12 }}>
        <button
          className={archived ? 'ghost' : ''}
          onClick={() => {
            setArchived(false);
            hapticFeedback('selection');
          }}
        >
          Upcoming
        </button>
        <button
          className={archived ? '' : 'ghost'}
          onClick={() => {
            setArchived(true);
            hapticFeedback('selection');
          }}
        >
          Archived
        </button>
      </div>
      {events.length === 0 && (
        <div className="empty">
          <div>No events yet.</div>
          <button style={{ marginTop: 12 }} onClick={openCreate}>Create the first event</button>
        </div>
      )}
      {events.map((ev) => (
        <div key={ev.id} className="card" onClick={() => (window.location.hash = `#/events/${ev.id}`)}>
          <h3>{ev.title}</h3>
          <div className="meta">{formatLocal(ev.starts_at)}</div>
          {ev.location && <div className="meta">📍 {ev.location}</div>}
          <div className="row" style={{ marginTop: 8, gap: 6 }}>
            <span className="rsvp-pill going">going {ev.rsvps?.going ?? 0}</span>
            <span className="rsvp-pill maybe">maybe {ev.rsvps?.maybe ?? 0}</span>
            <span className="rsvp-pill not_going">no {ev.rsvps?.not_going ?? 0}</span>
          </div>
        </div>
      ))}
    </div>
  );
}
